export default __webpack_public_path__ + "static/media/Kasala-imac-mockup_V1.1331b82f.jpg";